import _get from 'lodash/get';

export const getCurrentVirtualEventMeetingId = state =>
  _get(state, 'publicWebsite.currentVirtualEvent.virtual_meeting.meeting_id');

export const getThemeKey = state => _get(state, 'publicWebsite.wedding.theme.key');

export const getWeddingAccountId = state => _get(state, 'publicWebsite.wedding.wedding_account_id');

export const getPublicWebsiteWedding = state => _get(state, 'publicWebsite.wedding', {});

export const getPublicWebsite = state => _get(state, 'publicWebsite', {});

export const getPublicWebsitePage = state => _get(state, 'publicWebsite.page');

export const getRsvpSearchEnabled = state =>
  _get(state, 'publicWebsite.wedding.enable_rsvp_requests');

export const getRsvpSearchResults = state => _get(state, 'publicWebsite.guestSearch');

export const getGuestRsvpRequested = state => _get(state, 'publicWebsite.guestRequestSubmitted');

export const getGuestRsvpAccessForm = state => _get(state, 'publicWebsite.rsvpAccessForm');

export const getGuestGroupRsvp = state => _get(state, 'publicWebsite.guestGroupRsvp');

export const getRsvpShowSummary = state => _get(state, 'publicWebsite.rsvpShowSummary');

export const getPoiMapEnabled = state => _get(state, 'publicWebsite.wedding.enable_poi_maps');

export const getPublicWebsiteTheme = state => _get(state, 'publicWebsite.theme');

export const getPublicWebsiteThemeV2 = state =>
  _get(state, 'publicWebsite.wedding.public_theme_v2');

export const getPublicWebsiteThemeV2GroupKey = state =>
  _get(state, 'publicWebsite.wedding.public_theme_v2.theme_group_key');

export const getPublicWebsiteThemeV2GroupTitle = state =>
  _get(state, 'publicWebsite.wedding.public_theme_v2.theme_group_title');

export const getPublicWebsiteThemeV2Key = state =>
  _get(state, 'publicWebsite.wedding.public_theme_v2.key');

export const getPublicWebsiteThemeV2Motifs = state =>
  _get(state, 'publicWebsite.wedding.public_theme_v2.motif_keys');

export const getPublicWebsiteSlug = state => _get(state, 'publicWebsite.wedding.slug');
